import { environment } from "../utils/utility";

export const endPoints = {
    base: environment("API_URL", "http://localhost:3000/api"),
    files: "/files",
    users: "/users",
    getFullUrl: (path: string) => `${endPoints.base}${path}`,
}